import logo from './logo.svg';
import './App.css';
import Form from './Form.jsx';
import Header from './components/header';

function App() {
  return (
    <>
    <Header />
     <Form />
    </>
  );
}

export default App;
